import { merge1 } from "common/merge";
import { RawSystemTables, SystemTables } from "common/types/system-table";

export const rawToSystemTables = (rawSystemTables: RawSystemTables = []) =>
  rawSystemTables.reduce(
    (acc: SystemTables, { name, data }) => merge1(name, data, acc),
    {},
  );
